var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVirtualWorldsLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#fff",
    stroke: "#E5E8EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M79.7001 49.8501C79.7001 66.3358 66.3358 79.7001 49.8501 79.7001C33.3643 79.7001 20 66.3358 20 49.8501C20 33.3643 33.3643 20 49.8501 20C66.3358 20 79.7001 33.3643 79.7001 49.8501Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M79.7001 49.8501C79.7001 66.3358 66.3358 79.7001 49.8501 79.7001C33.3643 79.7001 20 66.3358 20 49.8501C20 33.3643 33.3643 20 49.8501 20C66.3358 20 79.7001 33.3643 79.7001 49.8501Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M79.7001 49.8501C79.7001 66.3358 66.3358 79.7001 49.8501 79.7001C33.3643 79.7001 20 66.3358 20 49.8501C20 33.3643 33.3643 20 49.8501 20C66.3358 20 79.7001 33.3643 79.7001 49.8501Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    d: "M79.7001 49.8501C79.7001 66.3358 66.3358 79.7001 49.8501 79.7001C33.3643 79.7001 20 66.3358 20 49.8501C20 33.3643 33.3643 20 49.8501 20C66.3358 20 79.7001 33.3643 79.7001 49.8501Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M79.7001 49.8501C79.7001 66.3358 66.3358 79.7001 49.8501 79.7001C33.3643 79.7001 20 66.3358 20 49.8501C20 33.3643 33.3643 20 49.8501 20C66.3358 20 79.7001 33.3643 79.7001 49.8501Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    fillRule: "evenodd",
    d: "M72.0993 29.9338H58.167C55.4056 29.9338 53.167 27.6952 53.167 24.9338V20.1661C60.6654 20.995 67.3268 24.6015 72.0993 29.9338Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    fillRule: "evenodd",
    d: "M36.2728 23.2416C36.4741 23.7836 36.584 24.3699 36.584 24.982V29.907C36.584 32.6685 38.8226 34.907 41.584 34.907H48.1674C50.9288 34.907 53.1674 37.1456 53.1674 39.907V44.8321C53.1674 47.5935 50.9288 49.8321 48.1674 49.8321H44.9007C42.1393 49.8321 39.9007 52.0706 39.9007 54.8321V59.7571C39.9007 62.5185 37.6621 64.7571 34.9007 64.7571H23.9936C21.4539 60.3665 20.0002 55.2691 20.0002 49.8321C20.0002 38.2358 26.6127 28.184 36.2728 23.2416Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    fillRule: "evenodd",
    d: "M66.3562 74.725C74.3992 69.3772 79.7001 60.2326 79.7001 49.85C79.7001 48.1549 79.5589 46.4928 79.2874 44.8749L73.0919 44.8749C70.3305 44.8749 68.0919 47.1135 68.0919 49.8749V54.7999C68.0919 57.5614 65.8533 59.7999 63.0919 59.7999H56.5085C53.7471 59.7999 51.5085 62.0385 51.5085 64.7999V69.725C51.5085 72.4864 53.7471 74.725 56.5085 74.725H66.3562Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 20,
    x2: 54.352,
    y1: 20,
    y2: 44.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B70C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2081E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 20,
    x2: 54.352,
    y1: 20,
    y2: 44.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B70C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2081E2",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualWorldsLight);
export default __webpack_public_path__ + "static/media/virtual-worlds-light.1ab1ccd4d248e39d872d61557f133291.svg";
export { ForwardRef as ReactComponent };